export const KEYS = {
  SUBJECT_ID: 'subjectId'
};

export const LABELS = {
  PASSWORD: "Password",
  HIDE_PASSWORD: "Hide Password",
  SHOW_PASSWORD: "Show Password",
  ASSOCIATE_USERS_WITH_ROLES: 'Associate Users with Roles',
  GENERAL: "General",
  USER_NAME: "User Name",
  IDENTITY_PROVIDER: "Identity Provider",
  SUBJECT_ID: "Subject ID",
  DISPLAY_NAME: "Display Name",
  NAME: "Name",
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  EMAIL: "Email",
  SIGN_IN_DETAILS: "Sign In Details",
  MOBILE_PHONE: "Mobile Phone",
  CONTACT_DETAILS: "Contact Details",
  SETTINGS: "Settings",
  USER_DETAIL: "User Detail",
  PREFERRED_MFA: "Preferred MFA",
  BLOCK_SIGN_IN: "Block Sign In",
  IS_MFA_ENABLED: "MFA Enabled?",
  ENABLE_MFA: 'Enable MFA',
  DEFAULT_EMPTY_VALUE: "-",
  EDIT: "Edit",
  BUTTON_RESET_PASSWORD: "Reset Password",
  BUTTON_RESET_MFA: "Reset MFA Enrolment",
  BUTTON_RESEND_INVITE: "Resend Invite",
  BUTTON_BLOCK_SIGN_IN: "Block Sign In",
  BUTTON_ALLOW_SIGN_IN: "Allow Sign In",
  ALLOW_SIGN_IN_TITLE: "Allow Sign In",
  BLOCK_SIGN_IN_TITLE: "Block Sign In",
  RESET_PASSWORD_TITLE: "Reset Password",
  RESET_MFA_TITLE: "Reset MFA Enrolment",
  BUTTON_CANCEL: "Cancel",
  BUTTON_CLOSE: "Close",
  BUTTON_SAVE: "Save",
  TEMPORARY_PASSWORD: 'Temporary Password',
  BUTTON_SAVE_SETTINGS: 'Save Settings',
  VALID_COLOR: "#27AE60",
  DEFAULT_COLOR: "#00000042",
  FORCE_RESET_PASSWORD: "Force reset password in next login",
};

export const MESSAGES = {
  PASSWORD_POLICY: 'Password Policy',
  SHOW_USER_PASSWORD: 'Show User Password',
  HIDE_USER_PASSWORD: 'Hide User Password',
  COPY_TO_CLIPBOARD: 'Copy To Clipboard',
  PASSWORD_COPIED_TO_CLIPBOARD: 'Password Copied To Clipboard',
  ERROR_IN_FETCHING_IDENTITY_PROVIDER_NAME: 'There is some problem in fetching Identity Provider, please contact your system administrator.',
  ALLOW_SIGNIN_SUCCESS: '{0} can now sign in',
  ALLOW_SIGNIN_ERROR: 'There was a problem allowing {0} to sign in',
  BLOCK_SIGNIN_SUCCESS: '{0} has been blocked from signing in',
  BLOCK_SIGNIN_ERROR: 'There was a problem in blocking {0} from signing in',
  PASSWORD_RESET_SUCCESS: 'Password for {0} has been reset',
  MFA_RESET_SUCCESS: 'Multi-Factor Authentication(MFA) for {0} has been reset',
  PASSWORD_RESET_FAILURE: 'There was a problem in resetting the password for {0}',
  MFA_RESET_FAILURE: 'Error while resetting Multi-Factor Authentication:',
  ALLOW_SIGN_IN_CONFIRMATION: "Are you sure you want to allow {0} to sign in",
  BLOCK_SIGN_IN_CONFIRMATION: "Are you sure you want to block {0} from signing in",
  RESET_PASSWORD_CONFIRMATION: "Are you sure you want to reset password for ",
  RESET_MFA_CONFIRMATION: "Are you sure you want to reset multi-factor authentication for ",
  RESEND_INVITE_CONFIRMATION: "Are you sure you want to resend invite for {0} ",
  RESEND_INVITE_SUCCESS: 'Invite has been resent to {0}',
  RESEND_INVITE_FAILURE: 'Error while resending invite:',
  USER_UPDATE_ERROR: 'There is some problem in updating user.',
  USER_NAME_REQUIRED: 'User Name is required',
  USER_NAME_INVALID: 'Please enter a valid User Name',
  MOBILE_NUMBER_INVALID: 'Please enter a valid Mobile Number',
  MOBILE_NUMBER_REQUIRED: 'Mobile Number is required',
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Please enter a valid Email',
  DISPLAY_NAME_REQUIRED: 'Diplay Name is required',
  PREFERRED_MFA_REQUIRED: 'Preferred MFA is required',
  FIRST_NAME_REQUIRED: 'First Name is required',
  LAST_NAME_REQUIRED: 'Last Name is required',
  PASSWORD_REQUIRED: 'Doesn\'t follow password policy',
  USER_UPDATE_SUCCESS: "User {0} details has been updated",
};

export const BINARY_OPTIONS = {
  YES: 'Yes',
  NO: "No"
};

export const STATUS_CODES = {
  ERROR_404: 404,
  ERROR_400: 400,
  ERROR_500: 500
};

export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};

export const LOCAL_USER_ONLY_FIELDS = [
  'isMfaEnabled',
  'mobilePhone',
  'preferredMfa'
];

export const PASSWORD_POLICY_ARRAY = {
  minMax: "Password length {0}-{1} characters",
  includeNumbers: "Numbers (e.g. 1, 2, 3, 4, etc.)",
  includeSpecialCharacters: "Special characters (e.g. !, @, #, $, etc.)",
  lettersInMixedCase: "Letters in mixed case (e.g. a, A, b, B, etc.)",
  maxConsecutiveLetters: "No more than {0} consecutive letters",
  commonPassword: "No common unsafe passwords (e.g. 123456, qwerty, etc.)"
};

export const FEDERATED_USER_INFO_MESSAGE = "Important: Please note that if the IDP sends values for the First Name, Last Name, Display Name, and Email fields, the information displayed on your screen will be replaced with the new information during your next login.";
